<!-- The template for this file is in /blocks/floorplans.php -->
<script>
export default {
  data() {
    return {
      plans: floorplanData.plans,
      towerFloorGroups: floorplanData.tower_floor_groups,
      terraceFloorGroups: floorplanData.terrace_floor_groups,
      activeBuilding: 'tower',
      activeFloorGroup: 'tower_3',
      activeUnit: null,
      activeBedroomOption: null
    }
  },
  methods: {
    getPlanById(planId) {
      return this.plans.find( plan => { return plan.id == planId } )
    },
    onSelectBuilding(building) {
      this.activeBuilding = building
      this.selectFirstLevelInBuilding(building)
      this.activeUnit = null
    },
    onSelectFloorGroup(floorGroupSlug) {
      this.activeFloorGroup = floorGroupSlug
      this.activeUnit = null
    },
    onSelectUnit(unitNumber) {
      this.activeUnit = unitNumber

      if ( window.screen.width < 768 ) {
        let floorplanPreview = document.querySelector('.wireframe-floorplan-outer')

        floorplanPreview.scrollIntoView({ behavior: 'smooth' })
      }
    },
    onApplyBedroomFilter(bedroomOption) {
      if ( this.activeBedroomOption !== bedroomOption ) {
        this.activeBedroomOption = bedroomOption
      } else  {
        this.activeBedroomOption = null
      }
    },
    onResetFilters() {
      this.selectFirstLevelInBuilding()
      this.activeUnit = null
      this.activeBedroomOption = null
    },
    onClosePreview() {
      this.activeUnit = null
    },
    selectFirstLevelInBuilding(building = this.activeBuilding) {
      let buildingFloorGroups = this[building + 'FloorGroups']
      this.activeFloorGroup = buildingFloorGroups[0].slug
    }
  },
  computed: {
    activeFloorGroupData() {
      let activeFloorGroupData = this[this.activeBuilding + 'FloorGroups'].find((floorGroup) => { return floorGroup.slug === this.activeFloorGroup })
      return activeFloorGroupData
    },
    activeUnitFloorplan() {
      if ( this.activeUnit ) {
        let activeUnitData = this.activeFloorGroupData.units.find((unit) => { return unit.number === this.activeUnit })
        
        return this.plans.find((plan) => { return plan.id === activeUnitData.plan_id })
      }
      
      return null
    },
    bedroomOptionsInFloorGroup() {
      let units = this.activeFloorGroupData.units
      let unitPlans = units.map((unit) => { return unit.plan_id })
      
      // Get all bedroom options for each unit on the floor
      let bedroomOptions = unitPlans.map((planId) => {
        let planData = this.plans.find((plan) => { return plan.id === planId })
        
        return planData.plan_type.value.split('_')[0]
      })

      let uniqueBedroomOptions = bedroomOptions.filter((item, pos) => {
        return bedroomOptions.indexOf(item) == pos
      })

      return uniqueBedroomOptions
    }
  },
  beforeMount() {
    if ( location.search ) {
      const urlParams = new URLSearchParams(location.search)
      if ( urlParams.has('floor_group') ) {
        let floorGroup = urlParams.get('floor_group')
        let building = floorGroup.split('_')[0]
        
        this.activeFloorGroup = floorGroup
        this.activeBuilding = building
      }
    }
  }
}
</script>